module.exports = __webpack_public_path__ + "img/Development phases-Impact characterisation.4c77aec1.svg";